import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconDirectionalSort = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--directional-sort")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-70.000000, -523.000000)"/>
          <g id="Icon/directional-sort" fill="currentColor">
              <path d="M12.3737047,1.42041774 L19.2602827,9.16781808 C19.4437417,9.37420946 19.4251514,9.69024565 19.21876,9.87370466 C19.1272344,9.95506072 19.0090352,10 18.8865781,10 L5.11342192,10 C4.83727955,10 4.61342192,9.77614237 4.61342192,9.5 C4.61342192,9.37754292 4.65836121,9.25934364 4.73971726,9.16781808 L11.6262953,1.42041774 C11.8097543,1.21402636 12.1257905,1.19543599 12.3321819,1.378895 C12.3468243,1.39191049 12.3606892,1.40577531 12.3737047,1.42041774 Z" id="icon--centivo--directional-sort"/>
              <path d="M12.3737047,12.4204177 L19.2602827,20.1678181 C19.4437417,20.3742095 19.4251514,20.6902457 19.21876,20.8737047 C19.1272344,20.9550607 19.0090352,21 18.8865781,21 L5.11342192,21 C4.83727955,21 4.61342192,20.7761424 4.61342192,20.5 C4.61342192,20.3775429 4.65836121,20.2593436 4.73971726,20.1678181 L11.6262953,12.4204177 C11.8097543,12.2140264 12.1257905,12.195436 12.3321819,12.378895 C12.3468243,12.3919105 12.3606892,12.4057753 12.3737047,12.4204177 Z" id="icon--centivo--directional-sort--1" transform="translate(12.000000, 16.500000) scale(1, -1) translate(-12.000000, -16.500000) "/>
          </g>
      </g>
  </IconWrapper>
)
